import {configureStore} from '@reduxjs/toolkit'
import stateMachineSlice from "./state-slice/stateMachineSlice";

export default configureStore({
    reducer: {
        stateMachine: stateMachineSlice
    }
})
